export const FILE_SIZE = {

  MAX_BYTES: 20 * 1024 * 1024,

  MAX_MB: 20,
} as const

export { ALLOWED_POLICY_MIME_TYPES } from '#shared/constants/membership'
